import { client } from "../../../../utils";

export const getNormalizersRequest = () => client.get("normalizer");

export const getConfigRequest = (id) => client.get(`config/${id}`);

export const createConfigRequest = (data) => client.post("configs", data);

export const editConfigRequest = ({ id, initialConfig }) => client.put(`config/${id}`, initialConfig);
